<template>
<el-dialog  title="协议" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="xieyiSGFlag" width="95%" center>
  <div>
    <div>
        <el-button type="primary" @click="xieyidayinFN">打印</el-button>
      </div>
      <div  id="printMe1" ref="print1" >
       <div style="page-break-after:always;">
      <!-- 打印 -->
        <div class="table_title">运输协议</div>
        <el-form :inline="true" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="150px" size="mini">
          <div class="inpBox">
            <el-form-item label="司机姓名:" >
              <span >{{rowData.driverName}}</span>
            </el-form-item>
            <el-form-item label="车牌号:" label-width="100px" >
              <span >{{rowData.plateNumber}}</span>
            </el-form-item>
            <el-form-item label="车辆类型:" >
              <span >{{rowData.vehicleTypeName}}</span>
            </el-form-item>
            <br>
            <el-form-item label="驾驶证号:" >
              <span>{{rowData.idNumber}}</span>
            </el-form-item>
            <el-form-item label="档案编号:" label-width="100px" >
              <span style="width:220px">{{rowData.orderNo}}</span>
            </el-form-item>
            <br>
            <el-form-item label="司机联系电话:" >
              <span>{{rowData.driverPhone}}</span>
            </el-form-item>
            <el-form-item label="委托期限:" label-width="100px" >
              <span style="width:200px"></span>
            </el-form-item>
            <br>
            <el-form-item label="承运人（司机）住址:" >
              <span></span>
            </el-form-item>
            <br>
            <el-form-item label="车属单位或车主:" >
              <span style="width:500px"></span>
            </el-form-item>
            <br>
            <el-form-item label="委托方地址/电话:" >
              <span style="width:500px">{{rowData.deliverPerson}}-{{rowData.deliverPhone}}-{{rowData.deliverAddress}}</span>
            </el-form-item>
            <br>

            <el-form-item label="收货方地址/电话:" >
              <span style="width:500px">{{rowData.receivingPerson}}-{{rowData.receivingPhone}}-{{rowData.receivingAddress}}</span>
            </el-form-item>
            <br>
            <el-form-item label="货物名称:" >
              <span>{{rowData.productTypeName}}</span>
            </el-form-item>
            <el-form-item label="共计运输:" >
              <span style="width:200px"></span>
            </el-form-item>
            <br>
            <el-form-item :label="'运输单价（元/'+rowData.measuringUnit+'）:'" >
              <span>{{rowData.freightUnitPrice?rowData.freightUnitPrice:'包干'}}</span>
            </el-form-item>
            <el-form-item label="运费合计（元）:" >
              <span></span>
            </el-form-item>
          </div>
          <h6>其他</h6>
          <p>1）货物交接后，由承运方负责送达目的地并承担丢失损坏造成的意外事故或未送达到目的地（迟送到目的地）的经济赔偿。（注：陶瓷洁具破损率为1.5%）</p>
          <p>2）运输途中过路、过桥、摆渡等一切费用由车主负责。</p>
          <p>3）承运方必须对托运方的运输货物交接手续，让收货方在回单上签字确认。如将随货单位丢失由此带来的一切损失由承运方承担</p>
          <p>4）运输车辆在装车前必须听从专业装车人员的安排，货物出厂前如提不出装车及货物是否损坏方面的异议（包括超重、超宽），视为承运方认可装车合格。如有异议请在第一时间通知：唐山曹妃甸兴瀚钢铁物流有限公司（汽运部调度室24小时电话：18931573605）。</p>
          <p>5）承运方对所承担的货物要采取保护措施，如彩涂卷、镀锌卷、加工配件等需加盖雨布、苫布，货物底部需垫草垫或三公分以上厚度皮带以固定货物防止运输过程中货物挤压、碰撞，因承运方个人疏忽导致货物受潮，磨损、挤压变形，损坏、丢失等造成的经济损失由承运方全部承担，并自损失之日起5日内处理完毕</p>
          <p>6）本合同一式两份，承运方，托运方各执一份</p>
          <el-form-item label="托运方（调度）签字:" >
            <span></span>
          </el-form-item>

          <el-form-item label=" 承运方（司机）签字:" >
            <span> </span>
          </el-form-item>
          <br>
          <span style="width:300px"> {{companyName}} </span>
          <div style="text-align: right;">
            <el-form-item label="" >
              <span>{{ timestamp|dateFormat }} </span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      </div>
  </div>
</el-dialog>
</template>
<script>
import { updateOrderBill, getOrderBill, getWMSGoodsPlus } from '@/api/newTMS'
export default {
  name: 'xiugaiSG',
  props: {
    xieyiSGFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      addFrom: {},
      timestamp: new Date().getTime(),
      companyName: localStorage.getItem('companyName')
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    console.log(this.rowData)
  },
  methods: {
    xieyidayinFN () {
      this.$print(this.$refs.print1)
    },
    closeDialog () {
      this.$emit('update:xieyiSGFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
#printMe1 {
  font-size: 14px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  .el-form-item span {
    display: inline-block;
    width: 150px;
  }
  .table_title {
    width: 100%;
    height: 40px;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
ul {
  width: 100%;
  display: flex;
  li {
    list-style: none;
    flex: 1;
    // color: black;
  }
}
</style>
